<template>
  <div>
    <div
      class="col-xs-12"
      style="display:flex; flex-wrap:wrap; flex: 1 0 auto"
    >
      <a
        v-for="course in courses"
        :id="course.id"
        :class="'course-block' + (selectedCourseId === course.id ? ' course-block-selected' : '')"
        @click="selectCourse(course)"
      >
        <span style="font-weight:bold;">{{ trans('core.course') }}: {{ course.title }}</span>
      </a>

      <button
        v-if="!openSuggest && numberOfCourses !== 0"
        class="btn-add-course"
        type="button"
        :title="trans('core.add_object', { 'object': trans('core.course') })"
        @click="openSuggestField"
      >
        <span style="font-weight:bold;">&plus;</span>
      </button>

      <suggest
        v-if="numberOfCourses === 0 || openSuggest"
        id="courseSelector"
        url="/employee/suggest/courses"
        :clear-on-select="true"
        :placeholder="trans('core.add_object', { 'object': trans('core.course') }) + '...'"
        :include="{ 'year': year }"
        :exclude="{ 'course_id': courseIds }"
        style="width: 200px; margin-top:5px;"
        autofocus
        :div-classes="'btn-group'"
        @select="addCourse"
      />
    </div>

    <br style="clear:both">

    <select-course-details
      v-if="selectedCourseId !== null"
      :course-id="selectedCourseId"
      @deleteCourse="deleteCourse"
    />
  </div>
</template>

<script>
import Suggest from './../Suggest.vue'
import SelectCourseDetails from './SelectCourseDetails.vue'
import { orderBy, pluck } from 'lodash'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'SelectLessons',
  components: { Suggest, SelectCourseDetails },

  props: {
    year: { required: true },
  },

  data () {
    return {
      openSuggest: false,
      selectedCourseId: null,
    }
  },

  computed: {
    courses () {
      return _.orderBy(this.$store.state.eventSeries.courses, 'added_on')
    },
    courseIds () {
      return this.courses.map(course => course.id)
    },
    numberOfCourses () {
      return this.courseIds.length
    },
  },

  created () {
    if (this.courseIds.length !== 0) {
      this.selectedCourseId = Number(this.courseIds[0])
    }
  },

  methods: {
    openSuggestField () {
      this.openSuggest = true
    },

    addCourse (courseId) {
      this.$store.dispatch('add_course', { courseId: courseId }).then(() => {
        this.openSuggest = false
        this.selectedCourseId = courseId
        this.$emit('canFinishStep')
      }).catch(error => defaultErrorMessage(error))
    },

    deleteCourse (courseId) {
      this.selectedCourseId = null
      let self = this
      this.$store.dispatch('remove_course', courseId).then(() => {
        if (this.numberOfCourses === 0) {
          self.$emit('canNotFinishStep')
        }
      })
    },

    selectCourse (course) {
      this.selectedCourseId = course.id
    },
  },
}
</script>

<style>
    .btn-add-course {
        display: inline-block;
        background-color: white;
        border: 1px solid lightgray;
        margin: 5px;
        padding: 5px 10px;
        text-align: center;
        border-radius: 50%;
    }

    .btn-add-course:hover {
        border: 2px solid #25167a !important;
    }

    .course-block {
        margin-right: 5px;
        margin-top: 2px;
        padding: 8px;
        border: 1px solid lightgray;
        cursor: pointer;
        color: black;
        font-weight: bold;
    }

    .course-block:hover {
        color: black;
        border: 2px solid #25167a !important;
    }

    .course-block-selected {
        border: 2px solid #25167a !important;
        background-color: lightgray;
    }

    .btn-primary {
        background-color: #25167a !important;
    }

</style>
